import { Link } from 'react-router'
export function NotFoundPage() { return <main className="route-state"><span>404</span><h1>页面不存在</h1><p>当前地址无效，或页面已经被移动。</p><Link to="/app/create/text-to-image">返回创作中心</Link></main> }
